import { AppSettings } from '../app.settings';
import { OtherScreenFiltersDataModel } from './other-screen-filters-data-model';

export class OtherScreenFilter {
    screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
    filterData: OtherScreenFiltersDataModel = new OtherScreenFiltersDataModel();
  
    constructor(options?: {
      screenCode?: String,
      filterData: OtherScreenFiltersDataModel
    }) {
      if (options) {
        this.screenCode = options.screenCode;
        this.filterData = options.filterData;
      }
    }
}
